export const isFlashcardsEnabled = () => {
  return !!(Fraction.Brand.Sidebar.Buttons.flashcards && Fraction.User);
};

export const areFlashcardFiguresEnabled = () => {
  return (
    isFlashcardsEnabled() &&
    Fraction.Brand.Sidebar.Buttons.figures &&
    Fraction.Brand.Flashcards.figuresEnabled
  );
};

export const areFlashcardPageImagesEnabledForBrand = () => {
  return isFlashcardsEnabled() && Fraction.Brand.Flashcards.figuresEnabled;
};
